<template>
  <div>
    <Modal v-model="model"  :mask-closable="false" width="90%" :title="title+'业务费用明细'">
    <div slot="close">
        <!-- <Button @click="close()" class="close-btn">关闭</Button> -->
        <Icon type="md-close" @click="close()" size=20 style="margin-top:5px;" />
      </div>
      <Card dis-hover style="min-height:400px;">
        <Form ref="queryForm" :label-width="100" label-position="left" inline>
		  <Row>
          <FormItem label="时间:">
            <DatePicker v-model="query.costTime" type="daterange" @on-change="dateChange" style="width: 260px" placement="bottom-end" placeholder="请选择"></DatePicker>
          </FormItem>
		  <FormItem label="节日礼品金额:">
		    <Input type="number" placeholder="" v-model="query.holidayGiftAmountStart" style="width: 120px;"></Input>至
		    <Input type="number" placeholder="" v-model="query.holidayGiftAmountEnd" style="width: 120px;"></Input>
		  </FormItem>
		  <FormItem label="业务费:">
			  <Input type="number" placeholder="" v-model="query.holidayGiftAmountStart" style="width: 120px;"></Input>至
			  <Input type="number" placeholder="" v-model="query.holidayGiftAmountEnd" style="width: 120px;"></Input>
		  </FormItem>
		  <FormItem label="商务活动:">
			  <Input type="number" placeholder="" v-model="query.holidayGiftAmountStart" style="width: 120px;"></Input>至
			  <Input type="number" placeholder="" v-model="query.holidayGiftAmountEnd" style="width: 120px;"></Input>
		  </FormItem><br>
		  </Row>
		  <Row>
          <FormItem label="业务员:">
            <Select v-model="query.salesman" style="width: 260px" >
              <Option :value="item.value" v-for="(item,index) in salesmanList" :key="index">{{item.name}}</Option>
            </Select>
          </FormItem>
		  <div class="totalPayPiont">节日礼品金额预算剩余：<span>{{residueHolidayGiftAmount}}</span>元&nbsp;&nbsp;  业务费剩余：<span>{{residueOperatingAmount}}</span>元&nbsp;&nbsp; 商务活动剩余：<span>{{residueBusinessActivityAmount}}</span>元</div>
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
			<Button @click="addSupperRow" icon="md-add" type="primary" size="default" class="toolbar-btn">添加</Button>
            <!-- <Button icon="md-add" type="primary" size="default" @click="openCreateLog" class="toolbar-btn">新增</Button> -->
			<Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate" class="toolbar-btn">下载导入模板</Button>
			<Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile" :headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false" :action="this.$constDefinition.baseUrl + `/Customerfile/UploadSalesExpenseBudgetDetail?customerSEBId=${this.customerSEBId}&&departmentType=${this.departmentType}` :data="importData">
			    <Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
			</Upload>
			<Button type="success" icon="md-archive" @click="exportFile" class="toolbar-btn">导出</Button>
          </Row>
        </Form>
		<div v-if="list">
			<!--  -->
				  <!-- ? TableRowAdd  Form嵌套住整个表格 使用行内规则-->
				  <Form ref="formAddSupperRowObj" :model="addSupperRowObj" :label-width="10">
				    <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list">
				      <!-- 数据 -->
				      <!-- ? TableRowAdd 插槽内每个都需要单独判断 -->
					  <!-- 客户简名  -->
					  <template slot-scope="{ row, index }" slot="costTimeText">
					    <div class="formItemArea" v-if="isModeEdit(row)">
					      <!-- ? TableRowAdd  编辑状态时显示输入框-->
					      <FormItem prop="costTimeText" :rules="{required: true, message: '请输入', trigger: 'blur' ,type:'date'}">
					        <DatePicker type="datetime" placeholder="请选择" :transfer="true" v-model="addSupperRowObj.costTimeText"></DatePicker>
					      </FormItem>
					    </div>
					    <div v-else>
					      <!-- ? TableRowAdd  普通状态时显示文字-->
					      {{ row.costTimeText }}
					    </div>
					  </template>
					  <!-- 业务员 -->
					  <template slot-scope="{ row, index }" slot="salesmanText">
					    <div class="formItemArea" v-if="isModeEdit(row)">
					      <!-- ? TableRowAdd  编辑状态时显示输入框-->
					      <FormItem prop="salesman" :rules="{required: true, message: '请选择', trigger: 'blur',type:'number'}">
							  <Select v-model="addSupperRowObj.salesman" :transfer="true" :disabled="true">
							  		<Option v-for="item in salesmanList" :value="item.value" :key="item.value">{{ item.name }}</Option>
							  </Select>
							  <!-- <Input type="text" placeholder="请输入" v-model="addSupperRowObj.salesmanText" disabled ></Input> -->
					      </FormItem>
					    </div>
					    <div v-else>
					      <!-- ? TableRowAdd  普通状态时显示文字-->
					      {{ row.salesmanText }}
					    </div>
					  </template>
					  
					  <!-- 节日礼品金额 -->
					  <template slot-scope="{ row, index }" slot="holidayGiftAmount">
					    <div class="formItemArea" v-if="isModeEdit(row)">
					      <!-- ? TableRowAdd  编辑状态时显示输入框-->
					      <FormItem prop="holidayGiftAmountRaw" :rules="{required: true, message: '请输入', trigger: 'blur'}">
					  			<Input placeholder="请输入" v-model.number="addSupperRowObj.holidayGiftAmountRaw" @input="formatHolidayGiftAmount" @on-change="calculateSubtotal()"></Input>
					      </FormItem>
					    </div>
					    <div v-else>
					      <!-- ? TableRowAdd  普通状态时显示文字-->
					      {{ row.holidayGiftAmountRaw }}
					    </div>
					  </template>
					  
					  
					  <!-- 业务费 -->
					  <template slot-scope="{ row, index }" slot="operatingAmount">
					  	<div class="formItemArea" v-if="isModeEdit(row)">
					  		<!-- ? TableRowAdd  编辑状态时显示输入框-->
					  		<FormItem prop="operatingAmountRaw"
					  			:rules="{required: true, message: '请输入', trigger: 'blur'}">
					  			<Input placeholder="请输入"
					  				v-model.number="addSupperRowObj.operatingAmountRaw"
					  				@input="formatOperatingAmount" @on-change="calculateSubtotal()"></Input>
					  		</FormItem>
					  	</div>
					  	<div v-else>
					  		<!-- ? TableRowAdd  普通状态时显示文字-->
					  		{{ row.operatingAmountRaw }}
					  	</div>
					  </template>
					  
					  <!-- 商务活动 -->
					  <template slot-scope="{ row, index }" slot="businessActivityAmount">
					  	<div class="formItemArea" v-if="isModeEdit(row)">
					  		<!-- ? TableRowAdd  编辑状态时显示输入框-->
					  		<FormItem prop="businessActivityAmountRaw"
					  			:rules="{required: true, message: '请输入', trigger: 'blur'}">
					  			<Input placeholder="请输入"
					  				v-model.number="addSupperRowObj.businessActivityAmountRaw"
					  				@input="formatBusinessActivityAmount" @on-change="calculateSubtotal()"></Input>
					  		</FormItem>
					  	</div>
					  	<div v-else>
					  		<!-- ? TableRowAdd  普通状态时显示文字-->
					  		{{ row.businessActivityAmountRaw }}
					  	</div>
					  </template>
					  
					  <!-- 小计 -->
					  <template slot-scope="{ row, index }" slot="subtotal">
					  	<div class="formItemArea" v-if="isModeEdit(row)">
					  		<!-- ? TableRowAdd  编辑状态时显示输入框-->
					  		<FormItem prop="subtotal">
					  			<Input type="number" placeholder="请输入" v-model.number="addSupperRowObj.subtotal"
					  				disabled></Input>
					  		</FormItem>
					  	</div>
					  	<div v-else>
					  		<!-- ? TableRowAdd  普通状态时显示文字-->
					  		{{ row.subtotalRaw }}
					  	</div>
					  </template>
					  
					  <!-- 目的 -->
					  <template slot-scope="{ row, index }" slot="objective">
					    <div class="formItemArea" v-if="isModeEdit(row)">
					      <!-- ? TableRowAdd  编辑状态时显示输入框-->
					      <FormItem prop="objective" :rules="{required: true, message: '请输入', trigger: 'blur'}">
					        <Input v-model="addSupperRowObj.objective" placeholder="请输入"></Input>
					      </FormItem>
					    </div>
					    <div v-else>
					      <!-- ? TableRowAdd  普通状态时显示文字-->
					      {{ row.objective }}
					    </div>
					  </template>
					  
				      <!-- 操作按钮 -->
				      <template slot-scope="{ row, index }" slot="action">
				        <!-- ? TableRowAdd 最好使用插槽模式不要用render  columns下slot属性-->
				        <!-- ? TableRowAdd 判断状态是否是新增add或者编辑edit -->
				        <template v-if="row.actionType == 'add' || row.actionType == 'edit'">
				          <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="saveSupperRow(row)">保存</Button>
				          <Button size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="cancelSupperRow(row,index)">取消</Button>
				        </template>
				        <template v-else>
				          <!-- ? TableRowAdd 当前行不为特殊状态时才显示以下操作-->
				          <!-- <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="() => { itemId = row.id; isAdd = '编辑'; createShow = true; }">编辑</Button> -->
				          <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="showLog(row)">操作日志</Button>
						  <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="editSupperRow(row,index)">编辑</Button>
				          <Button v-if="row.isShow删除" type="error" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="delCustomer(row)">删除</Button>
				        </template>
				      </template>
				    </Table>
				  </Form>
				  <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
				</div>
		
      </Card>
	  <Spin class="spin" fix v-if="spinShow" size="large">导入中...</Spin>
      <div slot="footer">
        <Button @click="close()" class="close-btn">关闭</Button>
      </div>
    </Modal>
    <div v-if="createLogModelShow">
      <createCostDetail :show="createLogModelShow" @close="closeModel" :customerSEBId="customerSEBId" :detailId="detailId" :departmentType="departmentType"></createCostDetail>
    </div>
	<div v-if="detailLogShow">
	<Modal title="操作日志" :value="detailLogShow" @on-cancel="closeLog" @on-ok="closeLog()" :mask-closable="false" width="600">
		 <div class="project">
		     <!-- 操作日志 -->
		       <Timeline>
		         <TimelineItem v-for="(log,index) in form.businessLogList" :key="index">
		           <p class="time">{{log.creatorName}}<span style="margin-left:10px;color:#b6b6b6;">{{log.creationTimeText}}</span></p>
		           <p class="content">{{log.content}}</p>
		         </TimelineItem>
		       </Timeline>
		 </div>
		 <Spin size="large" fix v-show="spinShow"></Spin>
	</Modal>
	</div>
  </div>
</template>
<script>
import Util from '../../../lib/util'
import moment from "moment";	
import createCostDetail from './createCostDetail.vue'
export default {
  components: { createCostDetail },
  props: {
    show: Boolean,
	title:String,
    customerSEBId: Number,
	departmentType:Number
  },
  data() {
    return {
      model: true,
      query: {
        costTime: [],
        salesman: null,
        costTimeStart: '',
        costTimeEnd: '',
		holidayGiftAmountStart:null,
		holidayGiftAmountEnd:null,
		operatingAmountStart:null,
		operatingAmountEnd:null,
		businessActivityAmountStart:null,
		businessActivityAmountEnd:null,
        customerSEBId: this.customerSEBId,
      },
	  requestHeader: {
	      Authorization: `Bearer ${Util.abp.auth.getToken()}`,
	  },
	  importData: {},
      columns: [], //项目表头
      list: [], //项目数据
      customerJMList:[],
      salesmanList:[],
	  salesman_Info:null,
	  disableSalesman:false,
	  spinShow:false,
      pageSize: 10,
	  detailId:null,
      currentPage: 1,
      totalCount: 0,
      loading: false,
	  form:[],
	  detailLogShow:false,
      createLogModelShow: false,
	  residueBusinessActivityAmount:0,
	  residueHolidayGiftAmount:0,
	  residueOperatingAmount:0,
	  addSupperRowObj: {
	    // ? TableRowAdd 添加、编辑时的数据缓存
	    customerSEBId: this.customerSEBId,
	    costTimeText: '',
	    salesman: null,
	    holidayGiftAmount:null,
	    holidayGiftAmountRaw:null,
	    operatingAmount:null,
	    operatingAmountRaw:null,
	    businessActivityAmount:null,
	    businessActivityAmountRaw:null,
	    subtotal:null,
	    subtotalRaw:null,
	    objective:'',
	    actionType: '',
	  },
    }
  },
  mounted() {
    this.getColumns()
    this.getSelectList()
    this.getpage(1)
  },
  methods: {
	  formatHolidayGiftAmount(event) {
	  	console.log(event);
	  	let value = event
	  	if (value) {
	  		// 移除所有非数字和小数点的字符
	  		let pureValue = value.replace(/[^\d.]/g, '');
	  
	  		// 将纯数值赋值给 this.addSupperRowObj.holidayGiftAmount
	  		this.addSupperRowObj.holidayGiftAmount = pureValue;
	  
	  		// 格式化数值，添加千位符
	  		let formattedValue = this.addThousandSeparator(pureValue);
	  		
	  		// 将格式化后的数值赋值给 this.addSupperRowObj.holidayGiftAmountRaw
	  		this.$set(this.addSupperRowObj, 'holidayGiftAmountRaw', formattedValue)
	  	}
	  },
	  formatOperatingAmount(event) {
	  	console.log(event);
	  	let value = event
	  	if (value) {
	  		// 移除所有非数字和小数点的字符
	  		let pureValue = value.replace(/[^\d.]/g, '');
	  
	  		// 将纯数值赋值给 this.addSupperRowObj.operatingAmount
	  		this.addSupperRowObj.operatingAmount = pureValue;
	  
	  		// 格式化数值，添加千位符
	  		let formattedValue = this.addThousandSeparator(pureValue);
	  		
	  		// 将格式化后的数值赋值给 this.addSupperRowObj.operatingAmountRaw
	  		this.$set(this.addSupperRowObj, 'operatingAmountRaw', formattedValue)
	  	}
	  },
	  formatBusinessActivityAmount(event) {
	  	console.log(event);
	  	let value = event
	  	if (value) {
	  		// 移除所有非数字和小数点的字符
	  		let pureValue = value.replace(/[^\d.]/g, '');
	  
	  		// 将纯数值赋值给 this.addSupperRowObj.businessActivityAmount
	  		this.addSupperRowObj.businessActivityAmount = pureValue;
	  
	  		// 格式化数值，添加千位符
	  		let formattedValue = this.addThousandSeparator(pureValue);
	  		
	  		// 将格式化后的数值赋值给 this.addSupperRowObj.businessActivityAmountRaw
	  		this.$set(this.addSupperRowObj, 'businessActivityAmountRaw', formattedValue)
	  	}
	  },
	  formatSubtotal(event) {
	  	console.log(event);
	  	let value = event
	  	if (value) {
	  		// 移除所有非数字和小数点的字符
	  		let pureValue = value.replace(/[^\d.]/g, '');
	  
	  		// 将纯数值赋值给 this.addSupperRowObj.subtotal
	  		this.addSupperRowObj.subtotal = pureValue;
	  
	  		// 格式化数值，添加千位符
	  		let formattedValue = this.addThousandSeparator(pureValue);
	  		
	  		// 将格式化后的数值赋值给 this.addSupperRowObj.subtotalRaw
	  		this.$set(this.addSupperRowObj, 'subtotalRaw', formattedValue)
	  	}
	  },
	  addThousandSeparator(value) {
	  	// 将数值部分和小数部分分开
	  	let parts = value.split('.');
	  	// 格式化整数部分，添加千位符
	  	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	  	// 重新组合整数部分和小数部分
	  	return parts.join('.');
	  },
    getColumns() {
      this.columns = [
        {
          title: '时间',
          slot: 'costTimeText',
        },
		{
		  title: '业务员',
		  slot: 'salesmanText',
		},
		{
		  title: '节日礼品金额',
		  slot: 'holidayGiftAmount',
		},
		{
		  title: '业务费',
		  slot: 'operatingAmount',
		},
		{
		  title: '商务活动',
		  slot: 'businessActivityAmount',
		},
		{
		  title: '小计',
		  slot: 'subtotal',
		},
		{
		  title: '目的/明细',
		  slot: 'objective',
		},
        // ? TableRowAdd 改插槽模式 slot: 'action',与table元素下slot保持一致
        {
          title: '操作',
          align: 'left',
          width: 200,
          slot: 'action',
        },
      ]
    },
	//   获取下拉框数据
	async getSelectList() {
	  const { data } = await this.$Ajax.get(
	    `/api/services/app/CustomerSalesExpenseBudgetDetailApiService/GetSalesExpenseBudgetDetailMgrInitData?customerSEBId=${this.customerSEBId}&&departmentType=${this.departmentType}`
	  )
	  this.salesmanList = data.result.salesmanData
	  this.salesman_Info=data.result.salesman
	  this.addSupperRowObj.salesman=this.salesman_Info
	  this.disableSalesman=data.result.HasCustomer
	},
    // 关闭弹窗
    close(refresh) {
      this.$emit('close', refresh)
    },
    closeModel(refresh) {
      this.createLogModelShow = false
      this.detailId=0
	  if(refresh){
        this.getpage(1)
      }
    },
	// 关闭弹窗
	closeLog() {
	this.detailLogShow=false
	},
    //新增日志
    openCreateLog() {
      this.createLogModelShow = true
    },
    //时间改变
    dateChange() {
      let time = this.query.costTime
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.query.costTimeStart = start
      this.query.costTimeEnd = end
    },
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/CustomerSalesExpenseBudgetDetailApiService/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.residueBusinessActivityAmount = data.data.result.residueBusinessActivityAmount
      this.residueHolidayGiftAmount = data.data.result.residueHolidayGiftAmount
      this.residueOperatingAmount = data.data.result.residueOperatingAmount
      this.loading = false
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
	// 创建产品
	openCreateProduct(detailId) {
	  this.detailId = detailId
	  this.createLogModelShow = true
	},
	async showLog(row) {
	  this.detailLogShow = true
	  const data = await this.$Ajax.get(`/api/services/app/CustomerSalesExpenseBudgetDetailApiService/GetDetailInfoById?id=`+row.id)
	  this.form = { ...data.data.result }
	  this.spinShow = false
	  console.log(this.detailLogShow);
	},
    reset() {
      this.query = {
        costTime: [],
        salesman: null,
        costTimeStart: '',
        costTimeEnd: '',
        holidayGiftAmountStart:null,
        holidayGiftAmountEnd:null,
        operatingAmountStart:null,
        operatingAmountEnd:null,
        businessActivityAmountStart:null,
        businessActivityAmountEnd:null,
        customerSEBId: this.customerSEBId,
      }
      this.getpage(1)
    },
	// 导入前处理
	beforeImportFile() {
	    this.spinShow = true;
	},
	// 导入成功
	importFile() {
	    this.$Message.success({
	        content: '导入成功',
	        duration: 3,
	    });
	    this.getpage();
	    this.spinShow = false;
	},
	// 导入失败
	errorImportFile(error, file, fileList) {
	    this.$Message.error({
	        content: file.error.message,
	        duration: 3,
	    });
	    this.getpage();
	    this.spinShow = false;
	},
	// 下载导入模板
	downLoadTemplate() {
	    this.downloadFile('/Customerfile/DownloadSalesExpenseBudgetDetailModel', '导入客户销售费用预算明细模板');
	},
	downloadFile(url, title) {
	    const date = moment(new Date()).format('yyyyMMDDHHmm');
	    let _this = this;
	    let consturl = this.$constDefinition.baseUrl + url; //下载地址url
	    var xhr = new XMLHttpRequest();
	    xhr.open('get', consturl, true); // get、post都可
	    xhr.responseType = 'blob';
	    xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`); //加请求头
	    xhr.onload = function () {
	        console.log(xhr);
	        if (xhr.status == 200) {
	            let blob = new Blob([this.response], {
	                type: 'application/vnd.ms-excel',
	            });
	            var a = document.createElement('a');
	            var url = window.URL.createObjectURL(blob);
	            a.href = url;
	            a.download = title + date + '.xlsx'; // 文件名
	            if (xhr.readyState === 4) {
	                _this.$Message.success({
	                    content: '下载成功',
	                    duration:3
	                });
	            }
	        } else {
	            _this.$Message.error({
	                content: '下载失败',
	                duration:3
	            });
	        }
	        a.click();
	        window.URL.revokeObjectURL(url);
	    };
	    xhr.send();
	},
	exportFile() {
	  var _this = this
	    this.$downLoad('/api/Export/ExportCustomerSalesExpenseBudgetDetail', '客户销售费用预算明细', '.xlsx',  this.params)
	},
	// ? TableRowAdd 判断是否处于编辑状态
	isModeEdit(row) {
	  if (row.actionType == 'add' || row.actionType == 'edit') {
	    return true
	  } else {
	    return false
	  }
	},
	// ? TableRowAdd 添加 添加一行
	addSupperRow() {
	  // 判断是否有正处于编辑状态的数据
	  if (
	    this.list.some((item) => {
	      return item.actionType === 'edit' || item.actionType === 'add'
	    })
	  ) {
	    //有正处于编辑状态的数据
	    this.$Message.error({
	      content: '请先保存添加的数据',
	      duration: 3,
	    })
	    return
	  }
	  this.clearSupperObj() //重置一下添加
	  this.addSupperRowObj.actionType = 'add' //操作状态 添加add 编辑edit
	  this.list.unshift(this.addSupperRowObj) //在数据最前面添加一行空行
	},
	editSupperRow(row, index) {
	  // 判断是否有正处于编辑状态的数据
	  //判断是否处于编辑状态
	  if (
	    this.list.some((item) => {
	      return item.actionType === 'edit' || item.actionType === 'add'
	    })
	  ) {
	    //有正处于编辑状态的数据
	    this.$Message.error({
	      content: '请先保存添加的数据',
	      duration: 3,
	    })
	    return
	  }
	  this.$set(this.list[index], 'actionType', 'edit') //通过下标使用set方法加上操作状态 添加add 编辑edit
	  let data = JSON.parse(JSON.stringify(row)) //转换一下使两份数据不指向同一内存地址(深拷贝)
	  data.costTimeText = new Date(row.costTime)
	  this.addSupperRowObj = data //编辑时把数据存起来
	},
	// ? TableRowAdd 取消添加/更改
	cancelSupperRow(row, index) {
	  // 判断是添加还是编辑
	  if (row.actionType == 'add') {
	    //添加时直接删除
	    this.list.shift() //在数据最前面删除一行
	  } else {
	    //编辑时还原数据
	    this.$set(this.list[index], 'actionType', '') //还原操作状态
	  }
	  this.clearSupperObj()
	},
	// ? TableRowAdd 添加编辑保存
	saveSupperRow(row) {
	  var _this=this
	  // formAddSupperRowObj确保不要有同样的ref否则$refs找不到
	  this.$refs['formAddSupperRowObj'].validate(async (valid) => {
	    if (valid) {
			this.addSupperRowObj.costTime = this.$moment(this.addSupperRowObj.costTimeText).format('YYYY-MM-DD HH:mm:ss')
			var url=''
	      // 判断是添加还是编辑
	      if (row.actionType == 'add') {
	        //添加时
	        try {
			  url='/api/services/app/CustomerSalesExpenseBudgetDetailApiService/Create'
			  let { data } = await this.$Ajax.post(
			  				url,
			  				this.addSupperRowObj
			  )
			  if (data.success) {
			  				this.$Message.success({
			  				  content: '添加成功',
			  				})
			  				_this.getpage()
			  }
	        } catch (error) {
	          this.$Message.error('添加失败')
	        }
	      } else {
	        //编辑时
	        try {
	          url='/api/services/app/CustomerSalesExpenseBudgetDetailApiService/Update'
	          let { data } = await this.$Ajax.put(
	            url,
	            this.addSupperRowObj
	          )
	          if (data.success) {
	            this.$Message.success({
	              content: '编辑成功',
	            })
	            _this.getpage()
	          }
	        } catch (error) {
	          this.$Message.error('编辑失败')
	        }
	      }
	    } else {
	      this.$Message.error('请按要求输入信息！')
	    }
	  })
	},
	
	// ? TableRowAdd 清空缓存数据
	clearSupperObj() {
	  this.addSupperRowObj = {
	    customerSEBId: this.customerSEBId,
	    costTimeText: '',
	    salesman: this.salesman_Info,
	    holidayGiftAmount:null,
	    operatingAmount:null,
	    businessActivityAmount:null,
	    subtotal:null,
	    objective:'',
	    actionType: '',
	  }
	},
	//删除
	delCustomer(row) {
	  this.$Modal.confirm({
	    title: '确认删除这条记录吗？',
	    okText: '确认',
	    cancelText: '取消',
	    onOk: async () => {
	      const { data } = await this.$Ajax.delete(
	        `/api/services/app/CustomerSalesExpenseBudgetDetailApiService/Delete?id=${row.id}`
	      )
	      if (data.success) {
	        this.$Message.success({ content: '删除成功', duration: 5 })
	      } else {
	        this.$Message.error({ content: '删除失败', duration: 5 })
	      }
	      this.getpage()
	    },
	  })
	},
	calculateSubtotal(){
		if(this.addSupperRowObj.holidayGiftAmount!=null  &&
		   this.addSupperRowObj.operatingAmount!=null  &&
		   this.addSupperRowObj.businessActivityAmount!=null  
		   ){
			   console.log("case1");
			this.addSupperRowObj.subtotal=parseFloat(this.addSupperRowObj.holidayGiftAmount)+ parseFloat(this.addSupperRowObj.operatingAmount)+ parseFloat(this.addSupperRowObj.businessActivityAmount)
		}
		else{
			console.log("case2");
			this.addSupperRowObj.subtotal=null;
		}
	},
  },
}
</script>
<style lang="less" scoped>
// /deep/.ivu-modal-fullscreen {
//   width: calc(~'100% - 256px') !important;
//   top: 0;
//   bottom: 0;
//   position: absolute;
//   left: 256px;
// }
/deep/ .ivu-table-expanded-cell {
  padding: 0;
  padding-left: 50px;
}
/deep/.ivu-form-item {
  margin-bottom: 10px;
}
/deep/.ivu-form-item-error {
  margin-bottom: 20px;
}
.formItemArea {
  margin-top: 10px;
}
.totalPayPiont {
  font-size: 15px;
  span {
    color: red;
    font-size: 19px;
  }
}
</style>